import { TeliaCol, TeliaRow, TeliaTextSpacing } from '@teliads/components/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import type { AssetLinks, Section } from './models';

import { renderRichText } from 'utils/rich-text-render';

import 'components/custom/content-block/ContentBlockPlainElements.scss';

interface Props {
  sections: Section[];
  assetLinks?: AssetLinks;
  isFullWidth?: boolean;
}

export default function ContentBlockPlainElements({
  sections,
  assetLinks,
  isFullWidth = false,
}: Props) {
  const path = useLocation();
  const { t } = useTranslation();
  const fullWidth =
    path.pathname?.includes(t('navigation.board_of_directors.slug')) ||
    path.pathname?.includes(t('navigation.group_executive_management.slug')) ||
    isFullWidth;

  return (
    <TeliaRow>
      <TeliaCol width={12} widthLg={fullWidth ? 12 : 8}>
        <TeliaTextSpacing>
          <div
            data-testid="content-block-plain-elements"
            className="content-block-plain-elements-wrapper"
          >
            {sections.map((section, index) => (
              <Fragment key={index}>{renderRichText(section.document, assetLinks)}</Fragment>
            ))}
          </div>
        </TeliaTextSpacing>
      </TeliaCol>
    </TeliaRow>
  );
}
